/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ago: NonNullable<unknown> }} Progress_When_WeekInputs */

const en_us2_progress_when_week = /** @type {(inputs: Progress_When_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.ago === 0 || i?.ago === "0")) return /** @type {LocalizedString} */ (`this week`);
	if ((i?.ago === 1 || i?.ago === "1")) return /** @type {LocalizedString} */ (`last week`);
	return /** @type {LocalizedString} */ (`${i?.ago} weeks ago`)
	
};

const pt_br2_progress_when_week = /** @type {(inputs: Progress_When_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.ago === 0 || i?.ago === "0")) return /** @type {LocalizedString} */ (`nesta semana`);
	if ((i?.ago === 1 || i?.ago === "1")) return /** @type {LocalizedString} */ (`na semana passada`);
	return /** @type {LocalizedString} */ (`há ${i?.ago} semanas`)
	
};

const es_419_progress_when_week = /** @type {(inputs: Progress_When_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.ago === 0 || i?.ago === "0")) return /** @type {LocalizedString} */ (`esta semana`);
	if ((i?.ago === 1 || i?.ago === "1")) return /** @type {LocalizedString} */ (`la semana pasada`);
	return /** @type {LocalizedString} */ (`hace ${i?.ago} semanas`)
	
};

const pt_pt2_progress_when_week = /** @type {(inputs: Progress_When_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.ago === 0 || i?.ago === "0")) return /** @type {LocalizedString} */ (`esta semana`);
	if ((i?.ago === 1 || i?.ago === "1")) return /** @type {LocalizedString} */ (`na semana passada`);
	return /** @type {LocalizedString} */ (`há ${i?.ago} semanas`)
	
};

const fr_fr2_progress_when_week = /** @type {(inputs: Progress_When_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.ago === 0 || i?.ago === "0")) return /** @type {LocalizedString} */ (`cette semaine`);
	if ((i?.ago === 1 || i?.ago === "1")) return /** @type {LocalizedString} */ (`la semaine dernière`);
	return /** @type {LocalizedString} */ (`il y a ${i?.ago} semaines`)
	
};

const de_de2_progress_when_week = /** @type {(inputs: Progress_When_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.ago === 0 || i?.ago === "0")) return /** @type {LocalizedString} */ (`diese Woche`);
	if ((i?.ago === 1 || i?.ago === "1")) return /** @type {LocalizedString} */ (`letzte Woche`);
	return /** @type {LocalizedString} */ (`vor ${i?.ago} Wochen`)
	
};

const it_it2_progress_when_week = /** @type {(inputs: Progress_When_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.ago === 0 || i?.ago === "0")) return /** @type {LocalizedString} */ (`questa settimana`);
	if ((i?.ago === 1 || i?.ago === "1")) return /** @type {LocalizedString} */ (`la settimana scorsa`);
	return /** @type {LocalizedString} */ (`${i?.ago} settimane fa`)
	
};

/**
* | ago | output |
* | --- | --- |
* | "0" | "this week" |
* | "1" | "last week" |
* | * | "{ago} weeks ago" |
*
* @param {Progress_When_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_when_week = /** @type {((inputs: Progress_When_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_When_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_when_week(inputs)
	if (locale === "es-419") return es_419_progress_when_week(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_when_week(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_when_week(inputs)
	if (locale === "de-DE") return de_de2_progress_when_week(inputs)
	if (locale === "it-IT") return it_it2_progress_when_week(inputs)
	return en_us2_progress_when_week(inputs)
});
export { progress_when_week as "progress.when_week" }